<template>
  <div class="pdf-generation-manual">
    <vue3-html2pdf
      ref="html2Pdf"
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="false"
      :paginate-elements-by-height="900"
      filename="FomoManualPass"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="landscape"
      pdf-content-width="1100px"
      @beforeDownload="beforeDownload"
    >
      <template #pdf-content>
        <section class="manual-pass-sheet">
          <article class="manual-pass-card">
            <aside class="manual-pass-card__rail">
              <span class="label">FOMO PASS</span>
              <strong>#{{ displayTicketNumber }}</strong>
              <small>{{ formatDateCompact(event.start_date) }}</small>
            </aside>
            <div class="manual-pass-card__body">
              <header class="manual-pass-card__header">
                <img v-if="event.banner_url" :src="event.banner_url" alt="Event Banner" class="manual-pass-card__banner" />
                <div class="manual-pass-card__hero">
                  <span class="label">Premium access</span>
                  <h1>{{ event.name || 'Evento FOMO' }}</h1>
                  <p>{{ venueLabel }}</p>
                </div>
              </header>
              <section class="manual-pass-card__meta-grid">
                <div class="meta-card"><span>Localidad</span><strong>{{ ticket.name || 'Acceso general' }}</strong></div>
                <div class="meta-card"><span>Asistente</span><strong>{{ attendeeName }}</strong></div>
                <div class="meta-card"><span>Fecha</span><strong>{{ formatDateLong(event.start_date) }}</strong></div>
                <div class="meta-card"><span>Asiento</span><strong>{{ ticket.seat_name || 'Acceso libre' }}</strong></div>
              </section>
              <footer class="manual-pass-card__footer">
                <div><span>Codigo de acceso</span><strong>{{ displayTicketCode }}</strong></div>
                <div><span>Orden</span><strong>#{{ invoice }}</strong></div>
                <div><span>Estado</span><strong>{{ displayStatus }}</strong></div>
              </footer>
            </div>
            <aside class="manual-pass-card__qr-panel">
              <div class="manual-pass-card__qr-shell">
                <qr-code :size="170" :text="ticketQrValue"></qr-code>
              </div>
              <div class="manual-pass-card__qr-copy">
                <span class="label">Validacion</span>
                <strong>{{ ticketCode }}</strong>
                <small>Presenta este QR en el ingreso para validacion manual.</small>
              </div>
            </aside>
          </article>
        </section>
      </template>
    </vue3-html2pdf>
  </div>
</template>

<script>
import Vue3Html2pdf from 'vue3-html2pdf'

export default {
  name: 'PdfGenerationManual',
  components: { Vue3Html2pdf },
  props: {
    ticket: { type: Object, required: true },
    event: { type: Object, required: true },
    invoice: { type: [Number, String], required: true },
  },
  computed: {
    attendeeName() {
      const fullName = `${this.ticket.first_name || ''} ${this.ticket.last_name || ''}`.trim()
      return fullName || this.ticket.holder_name || 'Sin nombre asignado'
    },
    venueLabel() {
      const venue = this.event.venue || {}
      const parts = [venue.name, venue.address, this.event.city].filter(Boolean)
      return parts.join(' - ' ) || 'Venue por confirmar'
    },
    ticketQrValue() {
      return `FOMO|MANUAL|${this.ticketCode}|${this.invoice}`
    },
    ticketCode() {
      return this.ticket.access_code_snapshot || this.ticket.code || `FOMO-${this.invoice}`
    },
    displayTicketCode() {
      const raw = String(this.ticketCode).replace(/[^A-Z0-9]/gi, '').toUpperCase()
      const compact = raw.slice(-12).padStart(12, '0')
      return `FOMO-${compact.slice(0, 4)}-${compact.slice(4, 8)}-${compact.slice(8, 12)}`
    },
    displayTicketNumber() {
      const number = this.ticket.number || this.ticket.ticket_number || this.ticket.id || '1'
      return `${this.invoice}-${number}`
    },
    displayStatus() {
      return this.ticket.status || this.ticket.payment_status || 'Activo'
    },
  },
  mounted() {
    this.generateReport()
  },
  methods: {
    generateReport() {
      if (this.$refs.html2Pdf) this.$refs.html2Pdf.generatePdf()
    },
    async beforeDownload({ html2pdf, options, pdfContent }) {
      await html2pdf().set(options).from(pdfContent).save()
      this.$emit('messageFromPdfGeneration')
    },
    formatDateCompact(value) {
      if (!value) return 'Fecha por confirmar'
      return new Intl.DateTimeFormat('es-EC', { month: 'short', day: '2-digit', year: 'numeric' }).format(new Date(value))
    },
    formatDateLong(value) {
      if (!value) return 'Fecha por confirmar'
      return new Intl.DateTimeFormat('es-EC', { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' }).format(new Date(value))
    },
  },
}
</script>

<style scoped>
.manual-pass-sheet { padding: 18px; background: radial-gradient(circle at top left, rgba(245,168,90,.12), transparent 24%), radial-gradient(circle at bottom right, rgba(84,153,199,.16), transparent 22%), #081019; }
.manual-pass-card { display: grid; grid-template-columns: 92px minmax(0,1fr) 240px; overflow: hidden; border-radius: 32px; background: linear-gradient(145deg, rgba(255,255,255,.05), rgba(255,255,255,.015)), linear-gradient(180deg, #0f1823, #09111a); border: 1px solid rgba(210,222,234,.12); box-shadow: 0 28px 60px rgba(0,0,0,.26); break-inside: avoid; }
.manual-pass-card__rail { display: grid; align-content: space-between; gap: 16px; padding: 22px 14px; background: linear-gradient(180deg, rgba(255,255,255,.07), rgba(255,255,255,.01)), linear-gradient(180deg, rgba(20,28,39,.98), rgba(8,14,22,.98)); border-right: 1px dashed rgba(210,222,234,.16); }
.manual-pass-card__body { display: grid; gap: 20px; padding: 24px; }
.manual-pass-card__header { display: grid; grid-template-columns: 128px minmax(0,1fr); gap: 20px; align-items: center; }
.manual-pass-card__banner { width: 128px; height: 128px; border-radius: 22px; object-fit: cover; display: block; box-shadow: 0 18px 34px rgba(0,0,0,.2); }
.manual-pass-card__hero { display: grid; gap: 8px; }
.manual-pass-card__hero h1 { margin: 0; color: #fff; font-size: 2rem; line-height: .96; font-family: "Bodoni Moda", serif; }
.manual-pass-card__hero p, .manual-pass-card__qr-copy small, .manual-pass-card__rail small { margin: 0; color: rgba(206,217,228,.84); line-height: 1.55; }
.manual-pass-card__meta-grid { display: grid; grid-template-columns: repeat(2, minmax(0,1fr)); gap: 12px; }
.meta-card { display: grid; gap: 6px; min-height: 86px; padding: 14px 16px; border-radius: 20px; background: rgba(255,255,255,.035); border: 1px solid rgba(210,222,234,.08); }
.manual-pass-card__footer { display: grid; grid-template-columns: repeat(3, minmax(0,1fr)); gap: 12px; padding-top: 10px; border-top: 1px solid rgba(210,222,234,.08); }
.manual-pass-card__qr-panel { display: grid; align-content: center; justify-items: center; gap: 14px; padding: 24px 18px; background: radial-gradient(circle at top, rgba(255,255,255,.08), transparent 24%), linear-gradient(180deg, rgba(15,23,34,.98), rgba(7,12,19,.98)); border-left: 1px solid rgba(210,222,234,.08); }
.manual-pass-card__qr-shell { padding: 14px; border-radius: 26px; background: #fff; box-shadow: 0 20px 38px rgba(0,0,0,.2); }
.manual-pass-card__qr-copy { display: grid; gap: 6px; justify-items: center; text-align: center; }
.label, .meta-card span, .manual-pass-card__footer span { color: #b8c5d3; font-size: .67rem; font-weight: 800; letter-spacing: .18em; text-transform: uppercase; }
.manual-pass-card__rail strong, .meta-card strong, .manual-pass-card__footer strong, .manual-pass-card__qr-copy strong { color: #fff; }
</style>